import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { toStoreDateString } from '@/common/helpers/dates'
import { getBlockName } from '@/configuration/pages/ConfigurationPage/OrderTrackingPageConfiguration/TrackingPageEditorModal/helpers'

import { getDateLimitedBlocks } from '../useBlockVisibility/helpers'

const usePreviewDate = ({ layout, getBlockVisibility, blockSettings, timeZone }) => {
  const { t } = useTranslation()
  const [previewDate, setPreviewDate] = useState(null)

  const changePreviewDate = value => setPreviewDate(toStoreDateString(value, timeZone))

  const unnamedDateLimitedBlocks = getDateLimitedBlocks({ layout, getBlockVisibility, date: previewDate, timeZone })

  const dateLimitedBlocks = unnamedDateLimitedBlocks.map(block => {
    return { ...block, name: getBlockName(block.blockId, blockSettings, t) }
  })

  return { previewDate, changePreviewDate, dateLimitedBlocks }
}

export default usePreviewDate
